<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                placeholder="搜索商品名称"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="分类">
              <a-cascader
                :options="cateOptions"
                placeholder="选择分类"
                changeOnSelect
                v-model="queryParam.cate_ids"
                :fieldNames="{
                  label: 'title',
                  value: 'key',
                  children: 'children',
                }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select
                v-model="queryParam.status"
                placeholder="请选择"
                allowClear
              >
                <a-select-option value="1">在售</a-select-option>
                <a-select-option value="2">下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <a-select
                showSearch
                optionFilterProp="title"
                v-model="queryParam.base_id"
                placeholder="选择供应商"
                allowClear
              >
                <a-select-option
                  :key="option.id"
                  v-for="option in baseOptions"
                  :title="option.name"
                  :value="option.id"
                  >{{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" style="display: flex; align-items: center">
      <a-button type="primary" icon="plus" @click="goodsAdd">新建</a-button>
      <a-button @click="download('base')" style="margin-left: 8px">
        商品明细下载
        <a-icon type="download" />
      </a-button>
      <a-button @click="downloadStock('base')" style="margin-left: 8px">
        商品库存下载
        <a-icon type="download" />
      </a-button>

      <div v-if="selectedRowKeys.length > 0">
        <a-popconfirm
          title="确定批量上架吗？"
          @confirm="setAllStatus(1)"
          okText="确定"
          cancelText="取消"
        >
          <a-button type="default">
            <a-icon type="upload" />
            批量上架
          </a-button>
        </a-popconfirm>
        <a-popconfirm
          title="确定批量下架吗？"
          @confirm="setAllStatus(2)"
          okText="确定"
          cancelText="取消"
        >
          <a-button type="default">
            <a-icon type="download" />
            批量下架
          </a-button>
        </a-popconfirm>
        <a-popconfirm
          title="删除后不可恢复,确定删除吗?"
          @confirm="goodsDeleteAll()"
          okText="确定"
          cancelText="取消"
        >
          <a-button type="default">
            <a-icon type="delete" />
            批量删除
          </a-button>
        </a-popconfirm>
      </div>
      <!--            <a-dropdown v-if="selectedRowKeys.length > 0">-->
      <!--                <a-menu slot="overlay">-->
      <!--                    <a-menu-item @click="setAllStatus(1)" key="1">-->
      <!--                        <a-icon type="upload"/>-->
      <!--                        上架-->
      <!--                    </a-menu-item>-->
      <!--                    <a-menu-item @click="setAllStatus(2)" key="2">-->
      <!--                        <a-icon type="download"/>-->
      <!--                        下架-->
      <!--                    </a-menu-item>-->

      <!--                    <a-menu-item key="3">-->
      <!--                        <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="goodsDeleteAll()" okText="确定" cancelText="取消">-->
      <!--                            <a href="javascript:;"><a-icon type="delete"/>删除</a>-->
      <!--                        </a-popconfirm>-->
      <!--&lt;!&ndash;                        <a-icon type="delete"/>&ndash;&gt;-->
      <!--&lt;!&ndash;                        删除&ndash;&gt;-->
      <!--                    </a-menu-item>-->
      <!--                </a-menu>-->
      <!--                <a-button style="margin-left: 8px">-->
      <!--                    批量操作-->
      <!--                    <a-icon type="down"/>-->
      <!--                </a-button>-->
      <!--            </a-dropdown>-->
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :rowClassName="getRowClassName"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="title1" slot-scope="text, record">
        <div style="margin-bottom: 10px">
          <a-tag color="pink" v-if="record.warning_stock_status" >库存预警</a-tag>{{ record.title }}
          <a-tag color="pink" v-if="record.isFenxiao == true">分销商品</a-tag
          ><a-tag color="blue" v-if="record.isFenxiaoOrder == true"
            >已有订单产出</a-tag
          >
          <div v-if="record.title_en" style="color:#999;font-size:12px;margin-top:4px;">{{ record.title_en }}</div>
        </div>
        <div>
          <img
            style="width: 68px; height: 68px; float: left"
            :src="record.pic_url"
          />
          <div style="color: #999; margin-left: 10px; float: left">
            <span
              style="color: #f5212d"
              v-if="record.price_range[0] != record.price_range[1]"
              >¥ {{ record.price_range[0] | price }} -
              {{ record.price_range[1] | price }}</span
            >
            <span style="color: #f5212d" v-else
              >¥ {{ record.price_range[0] | price }}</span
            >
            <a-divider type="vertical" />
            库存: {{ record.stock }} <br />
            <a-tag color="blue" v-if="record.sku_status == 1"
            >允许负库存</a-tag> 
            <br />{{ record.create_time | timeFormat }}
            <br />
            <a-badge status="success" v-if="record.status == 1" text="在售" />
            <a-badge status="default" v-else text="下架" />
          </div>
        </div>
      </span>
      <span slot="views" slot-scope="text, record">
        <template>
          <div>{{ record.views_count }}</div>
        </template>
      </span>
      <span slot="sold" slot-scope="text, record">
        <template>
          <div>{{ record.sold_count }}</div>
        </template>
      </span>
      <span slot="rank" slot-scope="text, record">
        <template>
          <editable-cell
            :text="text"
            @change="onRankChange(record.id, 'rank', $event)"
          />
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <!-- <span v-if="record.status==1">
            <a v-if="record.goods_recom==2" @click="onHandleRecom(record)" >推荐商品到首页</a>
              <a v-if="record.goods_recom==1" @click="NotHandleRecom(record)"  >取消推荐商品到首页</a>
              <a-divider type="vertical" />
          </span> -->

          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleSkuEdit(record)">编辑规格</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="删除后不可恢复,确定删除吗?"
            @confirm="deleteGoods(record)"
            okText="确定"
            cancelText="取消"
          >
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <GoodsSellerRewardForm
      :visible="sellerRewardVisible"
      :goodsId="sellerRewardGoodsId"
      @sellerRewardDone="sellerRewardDone"
    ></GoodsSellerRewardForm>
    <GoodsPartnerCashForm
      :visible="partnerCashVisible"
      :goodsId="partnerCashGoodsId"
      @sellerRewardDone="partnerCashDone"
    ></GoodsPartnerCashForm>
    <GoodsRewardForm
      :visible="rewardGoodsVisible"
      :goodsId="rewardGoodsId"
      @sellerRewardDone="() => (rewardGoodsVisible = false)"
    ></GoodsRewardForm>
    <GoodsMemberDiscountForm
      :visible="memberDiscountVisible"
      :goodsId="memberDiscountGoodsId"
      @sellerRewardDone="memberDiscountDone"
    ></GoodsMemberDiscountForm>
    <GoodsDealtownRewardForm
      :visible="dealtownRewardVisible"
      :goodsId="dealtownRewardGoodsId"
      @dealtownRewardDone="dealtownRewardDone"
    ></GoodsDealtownRewardForm>

    <a-modal
      :maskClosable="false"
      title="小程序推广"
      v-model="shareVisible"
      @ok="shareVisible = false"
    >
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
    </a-modal>
    <a-modal
      :maskClosable="false"
      title="H5推广"
      v-model="h5ShareVisible"
      @ok="h5ShareVisible = false"
    >
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
      <p>商品详情地址</p>
      <p>
        {{ share.site_url }} &nbsp;&nbsp;
        <a
          v-clipboard:copy="share.site_url"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >点此复制</a
        >
      </p>
    </a-modal>
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import GoodsMemberDiscountForm from "./GoodsMemberDiscountForm.vue";
import GoodsSellerRewardForm from "./GoodsSellerRewardForm.vue";
import GoodsPartnerCashForm from "./GoodsPartnerCashForm.vue";
import GoodsRewardForm from "./GoodsRewardForm.vue";
import GoodsDealtownRewardForm from "./GoodsDealtownRewardForm.vue";
import moment from "moment";
import PriceInput from "@/components/PriceInput/";

import {
  getGoodsList,
  getBaseOptions,
  getGoodsDownloadUrl,
  getGoodsStockDownloadUrl,
  getCateTreeList,
  setGoodsStatus,
  setGoodsAllStatus,
  deleteGoods,
  deleteGoodsAll,
  setGoodsRank,
  onHandleRecom,
  NotHandleRecom,
  setStockWarningCount,
} from "@/api/goods";

export default {
  name: "GoodsList",
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    GoodsSellerRewardForm,
    GoodsPartnerCashForm,
    GoodsDealtownRewardForm,
    GoodsMemberDiscountForm,
    PriceInput,
    GoodsRewardForm,
  },
  data() {
    return {
      visible: false,
      stock_warning_check: false,
      sellerRewardVisible: false,
      partnerCashVisible: false,
      rewardGoodsVisible: false,
      memberDiscountVisible: false,
      dealtownRewardVisible: false,
      memberDiscountGoodsId: 0,
      sellerRewardGoodsId: 0,
      partnerCashGoodsId: 0,
      rewardGoodsId: 0,
      dealtownRewardGoodsId: 0,
      saveLoading: false,
      shareVisible: false,
      h5ShareVisible: false,
      share: {
        site_url: "",
        wxmini_pic_url: "",
      },
      formData: {
        title: "",
        rules: [],
      },
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
      },
      cateOptions: [],
      baseOptions: [],
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "名称",
          dataIndex: "title",
          scopedSlots: { customRender: "title1" },
        },
        // {
        //   width: "100px",
        //   title: "点击数",
        //   dataIndex: "views_count",
        //   scopedSlots: { customRender: "views" },
        // },
        {
          title: "销量",
          width: "100px",
          dataIndex: "sold_count",
          scopedSlots: { customRender: "sold" },
        },
        {
          title: "排序",
          width: "150px",
          dataIndex: "rank",
          scopedSlots: { customRender: "rank" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: "320px",
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(parameter);
        this.queryParam.cate_id = 0;
        if (this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
          this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
        }
        this.queryParam = Object.assign(this.queryParam, parameter);
        console.log(this.queryParam);
        return getGoodsList(this.queryParam).then((res) => {
          console.log("res");

          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
    let that = this;
    getCateTreeList().then((res) => {
      that.cateOptions = res.data;
    });

    getBaseOptions().then((res) => {
      that.baseOptions = res.data;
    });
  },
  methods: {
    getRowClassName(record) {
      console.log(record);
      if (record.warning_stock_status) {
        return "table_h_style";
      } else {
        return "";
      }
    },
    download(type) {
      let that = this;
      getGoodsDownloadUrl(Object.assign(this.queryParam, { type: type }))
        .then((res) => {
          console.log(res);
          window.open(res.data);
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },
    downloadStock(type){
      let that = this;
      getGoodsStockDownloadUrl(Object.assign(this.queryParam, { type: type }))
        .then((res) => {
          console.log(res);
          window.open(res.data);
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },
    goodsAdd() {
      const { href } = this.$router.resolve({ name: "GoodsForm" });
      window.open(href, "_blank");
      // this.$router.push({
      // name: 'GoodsForm'
      // })
    },
    handleEdit(record) {
      const { href } = this.$router.resolve({
        name: "GoodsForm",
        query: { id: record.id },
      });
      // this.$router.push({
      // name: 'GoodsForm', query: {id: record.id}
      // })
      window.open(href, "_blank");
    },
    handleSkuEdit(record) {
      const { href } = this.$router.resolve({
        name: "GoodsForm",
        query: { id: record.id ,type:1},
      });
      // this.$router.push({
      // name: 'GoodsForm', query: {id: record.id}
      // })
      window.open(href, "_blank");
    },
    handleSellerReward(record) {
      let that = this;
      that.sellerRewardGoodsId = record.id;
      that.sellerRewardVisible = true;
    },

    handlePartnerCash(record) {
      let that = this;
      that.partnerCashGoodsId = record.id;
      that.partnerCashVisible = true;
    },

    handleSettingReward(record) {
      let that = this;
      that.rewardGoodsId = record.id;
      that.rewardGoodsVisible = true;
    },

    handleMemberDiscount(record) {
      let that = this;
      that.memberDiscountGoodsId = record.id;
      that.memberDiscountVisible = true;
    },
    handleDealtownReward(record) {
      let that = this;
      that.dealtownRewardGoodsId = record.id;
      that.dealtownRewardVisible = true;
    },
    //推荐到首页
    onHandleRecom(recode) {
      console.log(recode);
      onHandleRecom({ goods_id: recode.id })
        .then((res) => {
          this.$message.success("设置成功");
          this.$refs.table.refresh(true);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    //取消推荐到首页
    NotHandleRecom(recode) {
      NotHandleRecom({ goods_id: recode.id })
        .then((res) => {
          this.$message.success("设置成功");
          this.$refs.table.refresh(true);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    setAllStatus(status) {
      let self = this;
      setGoodsAllStatus({
        ids: self.selectedRowKeys,
        status: status,
      }).then((res) => {
        self.$message.success("设置成功");
        self.$refs.table.refresh(false);
      });
    },
    setStatus(goods_id, status) {
      setGoodsStatus({
        id: goods_id,
        status: status,
      }).then((res) => {
        self.$message.success("设置成功");
        self.$refs.table.refresh(false);
      });
    },

    // 批量删除商品
    goodsDeleteAll() {
      const self = this;
      deleteGoodsAll({
        ids: self.selectedRowKeys,
      }).then((res) => {
        self.$message.success("删除成功");
        self.$refs.table.refresh(false);
      });
    },

    // 删
    deleteGoods(record) {
      let self = this;
      deleteGoods({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setGoodsRank({
        id: key,
        rank: value,
      })
        .then((res) => {
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    sellerRewardDone() {
      this.sellerRewardVisible = false;
    },

    partnerCashDone() {
      this.partnerCashVisible = false;
    },
    memberDiscountDone() {
      this.memberDiscountVisible = false;
    },
    dealtownRewardDone() {
      this.dealtownRewardVisible = false;
    },
    onShare(record) {
      let that = this;
      that.shareVisible = true;
      that.share.wxmini_pic_url = record.wxmini_pic_url;
    },
    onH5Share(record) {
      console.log(record);
      let that = this;
      that.h5ShareVisible = true;
      that.share.site_url = record.h5_url;
      that.share.wxmini_pic_url = record.h5_pic_url;
    },
    onCopy(e) {
      this.$message.success("复制成功");
    },
    onError(e) {
      this.$message.error("复制失败");
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
};
</script>


<style>
.table_h_style {
  background: #ffcc99;
}
</style>